import { buildModelManager } from "../builder.js";
const DefaultQaCrewIdentitySelection = {
  __typename: true,
  id: true,
  active: true,
  createdAt: true,
  externalId: true,
  identityType: true,
  institution: true,
  normalizedPresentedName: true,
  presentedName: true,
  sourceMetadata: true,
  updatedAt: true,
  userId: true
};
const modelApiIdentifier = "qaCrewIdentity";
const pluralModelApiIdentifier = "qaCrewIdentities";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultQaCrewIdentitySelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultQaCrewIdentitySelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQaCrewIdentitySelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQaCrewIdentitySelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQaCrewIdentitySelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultQaCrewIdentitySelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultQaCrewIdentitySelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "qaCrewIdentityGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const QaCrewIdentityManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultQaCrewIdentitySelection,
  operations
);
export {
  DefaultQaCrewIdentitySelection,
  QaCrewIdentityManager
};
//# sourceMappingURL=QaCrewIdentity.js.map
